import React from 'react';

import usePage from '@dashboard/hooks/usePage';
import { PaymentsChargesList } from '@dashboard/scenes/PaymentsCharges';

import CardContent from '@dashboard/components/CardContent';
import CardListItem from '@dashboard/components/CardListItem';
import CardListItemElement from '@dashboard/components/CardListItemElement';

const SORT_DIRECTIONS = {
  ASCENDING: '1',
  DESCENDING: '-1',
};

const SORT_OPTIONS = {
  NEWEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Newest first',
  },
  OLDEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Oldest first',
  },
  EMAIL_ASCENDING: {
    value: 'email',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Email A-Z',
  },
  EMAIL_DESCENDING: {
    value: 'email',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Email Z-A',
  },
};

function RecentPayments() {
  const { page } = usePage();
  const sortBy = SORT_OPTIONS.NEWEST_FIRST.value;
  const sortDirection = SORT_DIRECTIONS.DESCENDING;

  const sort = {
    [sortBy]: sortDirection,
  };

  const filter = {
    page: page._id,
    livemode: true,
  };

  return (
    <div>
      <CardContent className="overflow-auto mb-20">
        <CardListItem variant="header" className="!bg-gray-50">
          <CardListItemElement size="3xl">Customer</CardListItemElement>
          <CardListItemElement size="xl">Amount</CardListItemElement>
          <CardListItemElement size="xl" align="right">
            Date
          </CardListItemElement>
          <CardListItemElement size="large">Abandonment</CardListItemElement>
          <CardListItemElement size="medium">Status</CardListItemElement>
        </CardListItem>

        <PaymentsChargesList
          pageType={page.type}
          sort={sort}
          filter={filter}
          options={{
            hidePaymentLink: true,
          }}
          infinite={false}
        />
      </CardContent>
    </div>
  );
}

export default RecentPayments;
